/**
 * Visits that are not going ahead. Mirrors the server's
 * CANCELLED_VISIT_STATUSES: nothing more happens on one, so the job's
 * completion no longer waits on anything filed against it.
 */
export const CANCELLED_VISIT_STATUSES: ReadonlySet<string> = new Set([
  'CANCELLED',
  'CANCELLATION_PENDING',
  'EXPIRED',
  'SKIPPED',
]);

/**
 * Visits that take no more records. Mirrors the server's
 * READ_ONLY_VISIT_STATUSES: offering one of these in a picker only lets
 * someone choose a visit the save will then refuse.
 */
export const READ_ONLY_VISIT_STATUSES: ReadonlySet<string> = new Set([
  'COMPLETED',
  ...CANCELLED_VISIT_STATUSES,
]);

export function visitTakesRecords(status: string | null | undefined): boolean {
  return !READ_ONLY_VISIT_STATUSES.has(String(status ?? ''));
}

export function isCancelledVisitStatus(status: string | null | undefined): boolean {
  return CANCELLED_VISIT_STATUSES.has(String(status ?? ''));
}
